import { useState } from "react";

import { useNavigate } from "react-router-dom";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import Box from "@mui/material/Box";
import { FestivalEditionLinks } from "views/festival-edition/components/select-previous-edition/components/festival-edition-links/festival-edition-links";

export const SelectPreviousEdition = ({ festival_edition }) => {
  const [edition, setEdition] = useState("");
  const navigate = useNavigate();

  const handleChange = (event) => {
    navigate(`/festival/${event.target.value}`);

    setEdition(
      festival_edition.festival.editions.find(
        (edition) => edition.slug === event.target.value,
      ).name,
    );
  };

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));

  return mobile ? (
    <Box mt={2} mb={1.5}>
      <FestivalEditionLinks
        festivalName={festival_edition.festival.name}
        festivalEditions={festival_edition.festival.editions}
      />
    </Box>
  ) : (
    <FormControl sx={{ minWidth: 250 }}>
      <Select
        displayEmpty
        value={edition}
        onChange={handleChange}
        input={<OutlinedInput />}
        renderValue={(selected) => {
          if (!selected) {
            return <em>Go to another year</em>;
          }

          return selected;
        }}
        // MenuProps={MenuProps}
        inputProps={{ "aria-label": "Without label" }}
      >
        <MenuItem disabled value="">
          <em>Go to another year</em>
        </MenuItem>

        {festival_edition.festival.editions.map((edition) => (
          <MenuItem key={edition.slug} name={edition.name} value={edition.slug}>
            {edition.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
